module.exports = __webpack_public_path__ + "media/images/icons/audio-5c8188340d9afe5ebbf4c267b132f990.svg";